import { useBoolean } from 'minimal-shared/hooks'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Cashback from '../components/cashback/Cashback'
import { useDebounce } from '../hooks/useDebounce'
import { usePreviousState } from '../hooks/usePreviousState'
import {
  changeCashbackState,
  // getCashbackBrandDetails,
  getCashbackBrands,
  getCashbackBrandsBySearch,
  getFilterCategories,
  resetCashbackState,
  selectCategoryForFilter
} from '../store/actions/cashback'
import { CASHBACK_PROFILE_DISPATCH } from '../store/reducers/cashback/cashback'
import { openExternalUrl } from '../util/app/app.helpers'
import {
  buildCurrencyByRegion,
  createCashbackTrackingUrl
} from '../util/cashback.helpers'

const CashbackContainer = ({
  getCashbackBrands,
  getCashbackBrandsBySearch,
  getFilterCategories,
  cashbackProfile,
  accountProfile,
  // getCashbackBrandDetails,
  changeCashbackState,
  resetCashbackState,
  selectCategoryForFilter,
  tokenProfile
}) => {
  const { t } = useTranslation()
  const {
    cashbackBrands,
    page,
    totalPages,
    isLast,
    loading,
    loadingBrand,
    filterCategories,
    // loadingDetails,
    checkedCategoriesForFilter
  } = cashbackProfile
  const { authId } = accountProfile

  const [query, setQuery] = useState('')

  const debouncedQuery = useDebounce(query)

  const prevQuery = usePreviousState(debouncedQuery)

  const openFilters = useBoolean()

  useEffect(() => {
    if (debouncedQuery.trim() !== '') {
      handleSearch(debouncedQuery)
    }
    if (prevQuery && !openFilters.value) {
      handleSearch()
    }
  }, [debouncedQuery])

  useEffect(() => {
    getCashbackBrands(0, true, false)
    getFilterCategories()
  }, [])

  useEffect(() => {
    return () => {
      resetCashbackState()
    }
  }, [])

  // useEffect(() => {
  //   if (selectedCashbackBrand) {
  //     if (!selectedCashbackBrand.trackingUrl) {
  //       getCashbackBrandDetails(selectedCashbackBrand.id)
  //     }
  //   }
  // }, [selectedCashbackBrand])

  const handleScroll = useCallback(() => {
    const currentPage = page + 1
    if (
      page < totalPages &&
      currentPage !== totalPages &&
      !query &&
      !loadingBrand
    ) {
      getCashbackBrands(currentPage, false, true)
    }
  }, [page, cashbackBrands, query])

  const handleCashbackShopNow = (trackingUrl) => {
    const url = createCashbackTrackingUrl(trackingUrl, authId)
    openExternalUrl(url)
  }

  const handleClearAll = () => {
    handleCancelFilters()
    getCashbackBrands(0, true, false)
  }

  const handleSearch = (searchTerm) => {
    if (searchTerm) {
      getCashbackBrandsBySearch(searchTerm, 0, true, false)
    } else {
      getCashbackBrands(0, true, false)
    }
    changeCashbackState(
      CASHBACK_PROFILE_DISPATCH.CHECKED_CATEGORIES_FOR_FILTER,
      {}
    )
  }

  const handleCancelFilters = () => {
    changeCashbackState(
      CASHBACK_PROFILE_DISPATCH.CHECKED_CATEGORIES_FOR_FILTER,
      {}
    )
  }

  const handleFilterItem = (id) => {
    setQuery('')
    selectCategoryForFilter(id)
  }

  const cashbackCurrency = useMemo(() => {
    return buildCurrencyByRegion(accountProfile.country)
  }, [accountProfile.country])

  return (
    <Cashback
      t={t}
      query={query}
      setQuery={setQuery}
      cashbackBrands={cashbackBrands}
      onCashbackShopNowClick={handleCashbackShopNow}
      checkedCategoriesForFilter={checkedCategoriesForFilter}
      loading={loading}
      scrollDataProps={{
        next: handleScroll,
        hasMore: !query && !isLast
      }}
      openFilters={openFilters}
      onClearAll={handleClearAll}
      filterCategories={filterCategories}
      onListItemClick={handleFilterItem}
      cashbackCurrency={cashbackCurrency}
      tokenProfile={tokenProfile}
      // loadingDetails={loadingDetails}
    />
  )
}

const mapStateToProps = ({ cashbackReducer, accountReducer, mainReducer }) => {
  const { cashbackProfile } = cashbackReducer
  const { accountProfile } = accountReducer
  const { tokenProfile } = mainReducer
  return {
    cashbackProfile,
    accountProfile,
    tokenProfile
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCashbackBrands,
      getCashbackBrandsBySearch,
      getFilterCategories,
      // getCashbackBrandDetails,
      changeCashbackState,
      resetCashbackState,
      selectCategoryForFilter
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(CashbackContainer)
